/* Витрина возможностей бота. ТЗ 6.8 — 4 сценария; реальный бот живёт в Telegram (раздел 9). */

import React from "react";

import { Ion } from "../components/icons.jsx";
import Screen from "../components/Screen.jsx";
import { Eyebrow, Hint, Pill } from "../components/ui.jsx";

const SCENARIOS = [
  {
    icon: Ion.chatbubbles,
    title: "Внести операцию текстом",
    input: "«расход 70к, зарплата Лере, из общака»",
    draft: [
      ["Тип", "Расход"],
      ["Сумма", "70 000 ₽"],
      ["Бизнес", "МЕРА"],
      ["Счёт", "Общак"],
      ["Категория", "Зарплата / ФОТ"],
      ["Контрагент", "Лера"],
    ],
    result: "→ Финучет · журнал, пересчёт ОДДС, P&L и балансов",
  },
  {
    icon: Ion.mic,
    title: "Голосовое сообщение",
    input: "🎤 0:14 — «Джет оплатил внедрение, двести сорок тысяч на счёт»",
    draft: [
      ["Расшифровка", "Джет оплатил внедрение, 240 000 на счёт"],
      ["Тип", "Поступление"],
      ["Сумма", "240 000 ₽"],
      ["Клиент", "Джет → проект acc-jet"],
      ["Счёт", "Расчётный счёт"],
    ],
    result: "→ Факт-выручка проекта «Джет», закрывает ожидание оплаты",
  },
  {
    icon: Ion.cloudUpload,
    title: "Файл в карточку проекта",
    input: "📎 Акт внедрения.pdf + «в проект Атлант»",
    draft: [
      ["Тип записи", "Вложение"],
      ["Файл", "Акт внедрения.pdf"],
      ["Куда", "Проект «Атлант»"],
    ],
    result: "→ Вложения карточки проекта",
  },
  {
    icon: Ion.sparkles,
    title: "Вопрос по данным",
    input: "«Дотягиваем до общака в этом месяце?»",
    draft: null,
    answer:
      "Средний кэшфлоу за 3 месяца — 879 000 ₽ при цели 1 250 000 ₽ (70%). Дефицит 371 000 ₽. " +
      "Ожидаем в июле: постоплату Атланта 209 000 ₽ и финальный платёж Окотана 156 250 ₽ — этого хватит, если оба зайдут в срок.",
    result: "→ Ответ без записи в базу",
  },
];

export default function BotDemo() {
  return (
    <Screen back>
      <div className="px-4 pt-1">
        <div className="card-tg px-4 py-3.5">
          <div className="flex items-center gap-2.5">
            <Ion.hardwareChip size={20} style={{ color: "var(--tg-button)" }} />
            <span className="display text-[16px] font-semibold">Как это работает</span>
          </div>
          <div className="mt-2 text-[14px] leading-snug">
            Пишете или наговариваете как человеку. ИИ раскладывает сказанное в структурированную запись,
            показывает карточку-подтверждение — и только после «Подтвердить» данные попадают в систему.
          </div>
          <div className="mt-2.5 flex flex-wrap gap-1.5">
            <Pill color="var(--fin-green)" bg="color-mix(in srgb, var(--fin-green) 12%, transparent)">
              текст
            </Pill>
            <Pill color="var(--fin-blue)" bg="color-mix(in srgb, var(--fin-blue) 12%, transparent)">
              голос
            </Pill>
            <Pill color="var(--fin-gold)" bg="color-mix(in srgb, var(--fin-gold) 12%, transparent)">
              файлы
            </Pill>
          </div>
        </div>
      </div>

      <Eyebrow>Сценарии</Eyebrow>
      <div className="px-4 flex flex-col gap-2">
        {SCENARIOS.map((s) => (
          <div key={s.title} className="card-tg px-4 py-3">
            <div className="flex items-center gap-2 mb-2">
              <s.icon size={16} style={{ color: "var(--tg-button)" }} />
              <span className="text-[15px] font-semibold">{s.title}</span>
            </div>

            <div
              className="rounded-xl px-3 py-2 text-[13px] leading-snug"
              style={{ background: "var(--tg-secondary-bg)" }}
            >
              {s.input}
            </div>

            {s.draft ? (
              <div className="mt-2 rounded-xl px-3 py-2" style={{ background: "var(--tg-secondary-bg)" }}>
                <div className="eyebrow px-0 pt-0 pb-1.5">Черновик к подтверждению</div>
                {s.draft.map(([k, v]) => (
                  <div key={k} className="flex items-baseline justify-between gap-3 py-0.5">
                    <span className="text-[12px]" style={{ color: "var(--tg-hint)" }}>{k}</span>
                    <span className="text-[13px] font-medium text-right">{v}</span>
                  </div>
                ))}
                <div className="mt-2 flex gap-2">
                  <span
                    className="flex-1 rounded-lg py-1.5 text-center text-[13px] font-semibold"
                    style={{ background: "var(--tg-button)", color: "var(--tg-button-text)" }}
                  >
                    ✅ Подтвердить
                  </span>
                  <span
                    className="flex-1 rounded-lg py-1.5 text-center text-[13px] font-semibold"
                    style={{ background: "var(--tg-section-bg)", color: "var(--tg-text)" }}
                  >
                    ✏️ Исправить
                  </span>
                </div>
              </div>
            ) : null}

            {s.answer ? (
              <div
                className="mt-2 rounded-xl px-3 py-2 text-[13px] leading-snug"
                style={{ background: "color-mix(in srgb, var(--tg-button) 8%, transparent)" }}
              >
                {s.answer}
              </div>
            ) : null}

            <div className="mt-2 flex items-center gap-1.5">
              <Ion.checkmarkCircle size={12} style={{ color: "var(--fin-green)" }} />
              <Hint>{s.result}</Hint>
            </div>
          </div>
        ))}
      </div>

      <Eyebrow>Проактивные уведомления</Eyebrow>
      <div className="px-4 pb-2">
        <div className="card-tg px-4 py-3 text-[13px] leading-snug">
          Бот сам, без запроса, присылает ответственному: просроченные задачи и неоплаченные счета — сразу
          или утренним дайджестом; «выставить счёт» — за 3 дня до даты платежа; «получить оплату» — в день
          платежа. Из бота можно посмотреть свои задачи и отметить выполненной.
        </div>
      </div>
    </Screen>
  );
}
